import FolderInfo from "./FolderInfo";

export default FolderInfo;